import React, { FC } from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { globalTheme } from '@cld/component-theme';
import Typography from '@cld/typography';
import { messages } from '../../../i18n';

const Root = styled.div`
  background: ${globalTheme.palette.contrastHigh};
`;

const TextWrapper = styled.div`
  padding: ${globalTheme.spacing.md} calc(${globalTheme.spacing.xl} * 8);
  margin: auto;
  max-width: calc(${globalTheme.spacing.lg} * 68);
`;

export const Sub: FC = () => (
  <Root>
    <TextWrapper>
      <Typography size="xs" type="contrastInvert" >
        &copy; <FormattedMessage {...messages['landing.footer.copyright']} />
      </Typography>
    </TextWrapper>
  </Root>
);
